if (!customElements.get('product-listing')) {
    customElements.define(
        'product-listing',
        class ProductListing extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
                this.sectionId = this.dataset.sectionId;
                this.selectors = {
                    sliderWrapper: '.product-listing__items',
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    headerPrev: '.swiper-header-prev-button-'+this.sectionId,
                    headerNext: '.swiper-header-next-button-'+this.sectionId,
                };
                this.classes = {
                    grid: 'f-grid',
                    swiper: 'swiper',
                    swiperWrapper: 'swiper-wrapper',
                };


                this.section = this.closest(`.section-${this.sectionId}`);
                this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

                this.enableSlider = this.dataset.enableSlider === 'true';
                this.headerSlider = this.dataset.headerSlider === 'true';
                this.items = parseInt(this.dataset.items);
                this.tabletItems = parseInt(this.dataset.tabletItems);

                this.sliderInstance = false;
                if(this.headerSlider){
                    if (window.innerWidth > 768) {
                        this.adjustDesktopBehavior()
                    }else{
                        const swipeContainer = document.querySelector('.scrolled-container-slider-'+this.sectionId);
                        const nextBtn = document.querySelector('.swiper-header-next-button-'+this.sectionId);
                        const prevBtn = document.querySelector('.swiper-header-prev-button-'+this.sectionId);
                        updateButtonState(swipeContainer, prevBtn, nextBtn);

                        function updateButtonState(container, prevBtn, nextBtn) {
                            const scrollLeft = container.scrollLeft;
                            const maxScrollLeft = container.scrollWidth - container.clientWidth;

                            // Prev button state
                            if (scrollLeft <= 2) {
                                prevBtn.classList.add('swiper-button-disabled');
                                prevBtn.setAttribute('disabled', 'true');
                            } else {
                                prevBtn.classList.remove('swiper-button-disabled');
                                prevBtn.removeAttribute('disabled');
                            }

                            // Next button state
                            const items = container.querySelectorAll('.f-column');
                            const lastItem = items[items.length - 1];
                            const containerRect = container.getBoundingClientRect();
                            const lastItemRect = lastItem.getBoundingClientRect();

                            if (lastItemRect.right <= containerRect.right + 1) { // +1 tolerans
                                // Son item görünüyorsa sadece butonu disable et
                                nextBtn.classList.add('swiper-button-disabled');
                                nextBtn.setAttribute('disabled', 'true');
                            } else {
                                nextBtn.classList.remove('swiper-button-disabled');
                                nextBtn.removeAttribute('disabled');
                            }
                        }
                        function scrollByPercentage(container, percentageOverride = null) {
                            const items = container.querySelectorAll('.f-column');
                            const totalItems = items.length;

                            if (totalItems <= 2) return 0;

                            const firstItem = items[0];
                            const itemStyles = window.getComputedStyle(firstItem);
                            const itemWidth = firstItem.offsetWidth;
                            const marginRight = parseFloat(itemStyles.marginRight) || 0;
                            const totalItemWidth = itemWidth + marginRight;

                            let percentage = percentageOverride;
                            if (!percentage) {
                                percentage = 100 / totalItems; // 🆕 Her zaman 100 / item sayısı
                            }
                            percentage += 2; // 🆕 +%2 pay

                            const scrollAmount = container.offsetWidth * (percentage / 100);
                            // document.querySelector('.section--dynamic-listing .dynamic-listing-header .view-header .section__heading').innerHTML = `Items: ${totalItems}, %: ${percentage}, Scroll: ${scrollAmount}px`;
                            return scrollAmount;
                        }
                        nextBtn.addEventListener('click', () => {
                            swipeContainer.scrollBy({
                                left: scrollByPercentage(swipeContainer, 25),
                                behavior: 'smooth'
                            });
                        });

                        prevBtn.addEventListener('click', () => {
                            swipeContainer.scrollBy({
                                left: -scrollByPercentage(swipeContainer, 25),
                                behavior: 'smooth'
                            });
                        });

                        nextBtn.addEventListener('click', () => {
                            swipeContainer.scrollBy({
                                left: scrollByPercentage(swipeContainer, 25),
                                behavior: 'smooth'
                            });
                            setTimeout(() => updateButtonState(swipeContainer, prevBtn, nextBtn), 300);
                        });

                        prevBtn.addEventListener('click', () => {
                            swipeContainer.scrollBy({
                                left: -scrollByPercentage(swipeContainer, 25),
                                behavior: 'smooth'
                            });
                            setTimeout(() => updateButtonState(swipeContainer, prevBtn, nextBtn), 300);
                        });

                        swipeContainer.addEventListener('scroll', () => {
                            updateButtonState(swipeContainer, prevBtn, nextBtn);
                        });
                    }


                }else{
                    if (!this.enableSlider) return;
                }


                const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
                mql.onchange = this.init.bind(this);
                this.init();
            }

            adjustDesktopBehavior() {
                if (window.innerWidth > 768) {
                    document.querySelectorAll('.product-listing__items').forEach(item => {
                        item.classList.forEach(cls => {
                            if (cls.startsWith('header-controlled-slider-')) {
                                item.classList.remove(cls);
                            }
                        });
                    });

                    document.querySelectorAll('.slider-controls--group').forEach(group => {
                        group.style.display = 'none';
                    });
                }
            }

            init() {
                if (FoxTheme.config.mqlMobile) {
                    this.destroySlider();
                } else {
                    this.initSlider();
                }
            }

            initSlider() {
                if (typeof this.sliderInstance === 'object') return;

                const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
                const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

                this.sliderOptions = {
                    modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
                    slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
                    spaceBetween: spaceBetween,
                    navigation: {
                        nextEl: this.section.querySelector(this.selectors.nextEl),
                        prevEl: this.section.querySelector(this.selectors.prevEl),
                    },
                    pagination: false,
                    breakpoints: {
                        1280: {
                            slidesPerView: parseInt(this.items),
                        },
                    },
                    loop: true,
                    threshold: 2,
                };
                if(this.headerSlider){
                    this.sliderOptions.navigation.nextEl = this.section.querySelector(this.selectors.headerNext);
                    this.sliderOptions.navigation.prevEl = this.section.querySelector(this.selectors.headerPrev);
                }

                this.classList.add(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.grid);
                this.sliderWrapper.classList.add(this.classes.swiperWrapper);

                this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
                this.sliderInstance.init();

                this.calcNavButtonsPosition();
                this.calcHeadingColumnHeight();
                this.fixQuickviewDuplicate();
            }

            destroySlider() {
                this.classList.remove(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
                this.sliderWrapper.classList.add(this.classes.grid);
                if (typeof this.sliderInstance !== 'object') return;
                this.sliderInstance.slider.destroy();
                this.sliderInstance = false;
            }

            calcNavButtonsPosition() {
                if (this.dataset.calcButtonPosition !== 'true') return;

                const firstMedia = this.querySelector('.product-card__image-wrapper');
                if (firstMedia && firstMedia.clientHeight > 0) {
                    this.section.style.setProperty(
                        '--swiper-navigation-top-offset',
                        parseInt(firstMedia.clientHeight) / 2 + 'px'
                    );
                }
            }

            calcHeadingColumnHeight() {
                if (this.dataset.calcHeadingColumnHeight !== 'true') return;

                const firstMedia = this.querySelector('.product-card__image-wrapper');
                if (firstMedia && firstMedia.clientHeight > 0) {
                    this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
                }
            }

            fixQuickviewDuplicate() {
                let modalIds = [];
                Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
                    const modalID = modal.getAttribute('id');
                    if (modalIds.includes(modalID)) {
                        modal.remove();
                    } else {
                        modalIds.push(modalID);
                    }
                });
            }
        }
    );
}
document.addEventListener("DOMContentLoaded", function () {
    const viewChangers = document.querySelectorAll("[data-view-changer]");
    viewChangers.forEach((changer) => {
        const sectionId = changer.getAttribute("data-section-id");
        const savedView = getCookie("view_preference_" + sectionId);
        if (savedView && window.innerWidth < 768) {
            change_view(savedView, sectionId);
        }else{

        }
    });
});
window.addEventListener('resize', updateView);

function updateIcon(type){
    if(type === "grid"){
        document.querySelector(".icon-grid").classList.remove("icon-opacity-50")
        document.querySelector(".icon-list").classList.add("icon-opacity-50")
    }else{
        document.querySelector(".icon-list").classList.remove("icon-opacity-50")
        document.querySelector(".icon-grid").classList.add("icon-opacity-50")
    }
}

function updateView() {
    const viewChangers = document.querySelectorAll("[data-view-changer]");
    viewChangers.forEach((changer) => {
        const sectionId = changer.getAttribute("data-section-id");
        const savedView = getCookie("view_preference_" + sectionId);
        const section = document.getElementById("shopify-section-" + sectionId).querySelector(".product-listing__items");
        if (window.innerWidth > 768) {
            setCookie("view_preference_" + savedView, "grid", 30);
            updateIcon("grid")
            section.classList.add("grid-view");
            section.classList.remove("list-view");
        }
    });
}
function change_view(type, id) {
    setCookie("view_preference_" + id, type, 30);
    const section = document.getElementById("shopify-section-" + id).querySelector(".product-listing__items");
    if (section) {
        if (type === 'list') {
            section.classList.add("list-view");
            section.classList.remove("grid-view");
            updateIcon("list")
        } else if (type === 'grid') {
            section.classList.add("grid-view");
            section.classList.remove("list-view");
            updateIcon("grid")
        }
    }
}

function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
}

function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}
